<ion-row class="content">
  <ion-col size="6" class="column">
    <!--Assigned Values -->
    <app-column-form
      [header]="assignedHeaderText"
      [buttonText]="assignedButtonText"
      [iconName]="assignedButtonIcon"
      [data]="assignedData"
      [disable]="disableAssignedColumn"
      [searchPlaceholder]="assignedSearchPlaceholderText"
      (emitCheckboxesSelected)="onCheckValue($event, false)"
      (emitAssignUnassign)="onAssignUnassign($event, true)"
    ></app-column-form>
    <!------------------->
  </ion-col>
  <ion-col size="6" class="column">
    <!--Available Values -->
    <app-column-form
      [header]="availableHeaderText"
      [buttonText]="availableButtonText"
      [iconName]="availableButtonIcon"
      [data]="availableData"
      [disable]="disableAvailableColumn"
      [searchPlaceholder]="availableSearchPlaceholderText"
      (emitCheckboxesSelected)="onCheckValue($event, true)"
      (emitAssignUnassign)="onAssignUnassign($event, false)"
    ></app-column-form>
    <!------------------->
  </ion-col>
</ion-row>
